<template>
  <v-navigation-drawer
    class="navigation"
    fixed
    permanent
    expand-on-hover
    dark
    width="300"
  >
    <v-list>
      <!-- <v-list-item class="px-2">
        <v-list-item-avatar>
          <img
            width="125"
            src="../assets/images/logo/gc_white.svg"
            :lazy-src="require('../assets/images/lazy-loading.png')"
            alt="Logo"
          />
        </v-list-item-avatar>
      </v-list-item> -->

      <v-list-item link v-if="currentUser">
        <v-list-item-content class="visible-closed px-0">
          <v-list-item-title class="subtitle-2 px-0">{{
            `${currentUser.name.charAt(0).toUpperCase()} ${currentUser.lastName
              .charAt(0)
              .toUpperCase()}`
          }}</v-list-item-title>
          <v-list-item-subtitle class="visibility-hidden text-caption">{{
            currentUser.email
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content class="visible-opened">
          <v-list-item-title class="text-h6 font-weight-medium">{{
            `${currentUser.name} ${currentUser.lastName}`
          }}</v-list-item-title>
          <v-list-item-subtitle class="text-body-2 text-medium-emphasis">{{
            currentUser.email
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>
    <div class="pos-rel">
      <v-list nav dense>
        <v-list-item
          link
          :to="item.link"
          v-for="(item, index) in itemsFiltered"
          :key="index"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-subtitle-1 font-weight-medium">{{ item.title }}</v-list-item-title>
        </v-list-item>
        <!-- todo family tree -->
        <!-- <v-list-item link to="/FamilyTree">
        <v-list-item-icon>
          <v-icon>mdi-tree-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{lang.menuLinks.familyTree}}</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/">
        <v-list-item-icon>
          <v-icon>mdi-shield-plus-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{lang.menuLinks.addCommercials}}</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/">
        <v-list-item-icon>
          <v-icon>mdi-shield-star-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{lang.menuLinks.myCommercials}}</v-list-item-title>
      </v-list-item> -->
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Navigation",
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters("user", ["currentUser"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    itemsFiltered() {
      return this.items.filter((el) => el.show);
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.visibility-hidden {
  visibility: hidden;
}
.visible-opened {
  // transition-delay: 500ms !important;
  transition: opacity 1200ms ease-out;
  opacity: 0;
  height: 0;
  width: 0;
  overflow: hidden;
}
.pos-rel {
  position: relative;
}
.vertical-logo {
  position: absolute;
  transform: rotate(-90deg);
  left: -70px;
  top: 100px;
  font-weight: 600;
  color: #fff;
  transition-delay: 300ms !important;
  transition: opacity 400ms ease-in;
  opacity: 0;
  height: 0;
  overflow: hidden;
  font-size: 1.25rem;
  letter-spacing: 0.5px;
}
.v-navigation-drawer--is-mouseover {
  .visible-closed {
    display: none;
  }
  .visible-opened {
    opacity: 1;
    height: auto;
    width: auto;
  }
  .vertical-logo {
    opacity: 1;
    height: auto;
  }
}
.no-theme {
  @import "../assets/scss/_variables";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-default {
  @import "../assets/scss/_variables";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-black {
  @import "../assets/scss/_variables_black";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-blue-gray {
  @import "../assets/scss/_variables_blue_grey";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-blue {
  @import "../assets/scss/_variables_blue";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-cyan {
  @import "../assets/scss/_variables_cyan";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-dark-red {
  @import "../assets/scss/_variables_dark_red";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-green {
  @import "../assets/scss/_variables_light_green";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-light-green {
  @import "../assets/scss/_variables_green";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-light-brown {
  @import "../assets/scss/_variables_light_brown";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-lime-dark {
  @import "../assets/scss/_variables_lime_dark";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-orange {
  @import "../assets/scss/_variables_orange";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-pink {
  @import "../assets/scss/_variables_pink";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-light-purple {
  @import "../assets/scss/_variables_purple_light";
  .navigation {
    background: $bg-color-navigation;
  }
}

.theme-purple {
  @import "../assets/scss/_variables_purple";
  .navigation {
    background: $bg-color-navigation;
  }
}
.navigation {
  z-index: 100 !important;
  width: 450px;
}
</style>